module.exports = __webpack_public_path__ + "img/logo-sm.4a32781d.png";